import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  userAreaTrigger: {
    display: "flex",
    alignItems: "center",
  },
  userName: {
    transition: "text-decoration-color 0.15s ease",
    textDecoration: "underline",
    textDecorationColor: "transparent",
    textDecorationThickness: "1.5px",
    textUnderlineOffset: "3px",
    "$person:hover &": {
      textDecorationColor: "currentColor",
    },
  },
  caretButton: {
    padding: "6px !important",
    marginLeft: "-2px",
    color: "var(--color-primary-contrast) !important",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.14) !important",
    },
  },
  paper: {
    zIndex: 1300,
    "& .MuiPaper-root": {
      width: "max-content",
      minWidth: 180,
      maxWidth: 280,
      borderRadius: 14,
      overflow: "hidden",
      backgroundColor: "var(--color-background-paper)",
      border: "1px solid var(--color-border)",
      boxShadow: "0 12px 32px rgba(0, 0, 0, 0.18)",
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: "-8px",
    },
  },
  profileTrigger: {
    display: "inline-flex",
    alignItems: "center",
  },
  personDisabled: {
    cursor: "not-allowed !important",
    "&:hover $userName": {
      textDecorationColor: "transparent !important",
    },
  },
  person: {
    whiteSpace: "nowrap",
    color: "var(--color-primary-contrast)",
    fontSize: "0.8125rem !important",
    textTransform: "none",
    "& .MuiButton-startIcon": {
      "& > *": {
        fontSize: "0.8125rem !important",
      },
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      textAlign: "center",
      minWidth: "auto !important",
      padding: "6px !important",
      "& .MuiButton-label": {
        fontSize: "0 !important",
      },
      "& .MuiButton-startIcon": {
        margin: 0,
      },
    },
  },
  dropdownArrow: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(255, 255, 255, 0.7)",
    transition: "transform 0.2s ease, color 0.2s ease",
    "& svg": {
      width: "11px !important",
      height: "11px !important",
    },
  },
  dropdownArrowOpen: {
    transform: "rotate(180deg)",
    color: "var(--color-primary-contrast)",
  },
  avatarFallback: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    border: "2px solid rgba(255, 255, 255, 0.4)",
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.28), rgba(255, 255, 255, 0.08))",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
    color: "var(--color-primary-contrast)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: "14px !important",
      height: "14px !important",
    },
  },
  hideProfileSetting: {
    display: "none",
  },
  nowrap: {
    whiteSpace: "nowrap",
  },
  InfoIcon: { fontSize: "0.875rem", color: "gray" },
  themeMenuIcon: {
    minWidth: 36,
    color: "var(--color-text-secondary)",
  },
  themeMenuItem: {
    alignItems: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  themeMenuText: {
    margin: 0,
  },
  themeMenuPrimary: {
    fontSize: "0.95rem",
    fontWeight: 500,
    lineHeight: 1.2,
    color: "var(--color-text-primary)",
  },
  themeMenuSecondary: {
    fontSize: "0.8rem",
    lineHeight: 1.25,
    marginTop: 2,
    color: "var(--color-text-secondary)",
  },
  userAvatar: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid rgba(255, 255, 255, 0.4)",
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    display: "block",
  },
  profileAvatarImage: {
    width: 40,
    height: 40,
    margin: theme.spacing(1),
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid var(--color-background-paper)",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.25)",
    display: "block",
  },
  avatarFallbackLarge: {
    width: 40,
    height: 40,
    margin: theme.spacing(1),
    borderRadius: "50%",
    backgroundColor: "var(--color-background-paper)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
    color: "var(--color-primary-main)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: "18px !important",
      height: "18px !important",
    },
  },
  profileMenuList: {
    padding: theme.spacing(0.75),
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: 10,
  },
  profileMenuHeader: {
    listStyle: "none",
    padding: theme.spacing(1.25, 1.5, 1),
    minWidth: 0,
  },
  profileMenuName: {
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: 1.4,
    color: "var(--color-text-primary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  profileMenuEmail: {
    fontSize: "0.75rem",
    lineHeight: 1.4,
    marginTop: 1,
    color: "var(--color-text-secondary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  profileMenuItem: {
    minHeight: 40,
    padding: theme.spacing(1, 1.25),
    borderRadius: 9,
    color: "var(--color-text-primary)",
    transition: "background-color 0.15s ease, color 0.15s ease",
    "&:hover, &.MuiListItem-button:hover": {
      backgroundColor: "var(--total_row_background)",
    },
    "&:hover $profileMenuItemIcon": {
      color: "var(--color-primary-text)",
    },
  },
  profileMenuItemIcon: {
    marginRight: theme.spacing(1.25),
    color: "var(--color-text-secondary)",
    transition: "color 0.15s ease",
    "&.MuiSvgIcon-root": {
      fontSize: "1.15rem",
    },
  },
  profileMenuItemText: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.2,
    color: "inherit",
    transition: "color 0.15s ease",
  },
  menuDivider: {
    height: 1,
    margin: theme.spacing(0.5, 0.75),
    backgroundColor: "var(--total_row_boldbackground)",
    listStyle: "none",
  },
  profileLogoutItem: {
    "&:hover, &.MuiListItem-button:hover": {
      backgroundColor: "rgba(211, 47, 47, 0.08)",
    },
    "&:hover $profileMenuItemIcon": {
      color: "var(--error-color)",
    },
    "&:hover $profileMenuItemText": {
      color: "var(--error-color)",
    },
  },
}));

export default useStyles;
